import { render, staticRenderFns } from "./atoForm.vue?vue&type=template&id=5ff30390&scoped=true"
import script from "./atoForm.vue?vue&type=script&lang=js"
export * from "./atoForm.vue?vue&type=script&lang=js"
import style0 from "./atoForm.vue?vue&type=style&index=0&id=5ff30390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff30390",
  null
  
)

export default component.exports